// extracted by mini-css-extract-plugin
export default {"videoContainer":"videoContainer-amwBX"};